import { VFC } from 'react'
import { CwsHeaderLocaleSelector, CwsHeaderLocale, CwsA, CwsHeaderLocaleSelectorGroup } from '@components/cws'
import { Locale } from '@model/locales'
import { useTranslate } from '@hooks/useTranslation'

interface LanguagePickerProps {
  selectedLanguageCode: string
  onSelectLanguage: (locale: Locale) => void
}

export const LanguageSelector: VFC<LanguagePickerProps> = ({ selectedLanguageCode, onSelectLanguage }) => {
  const { translate } = useTranslate()

  return (
    <CwsHeaderLocale>
      <CwsHeaderLocaleSelector mode="language" label={`${translate('nav.btn.language')}`}>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'et'}>
          <CwsA onClick={() => onSelectLanguage('et')} hideArrow href="#">
            Eesti keel
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'fi'}>
          <CwsA onClick={() => onSelectLanguage('fi')} hideArrow href="#">
            Suomi
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'sv'}>
          <CwsA onClick={() => onSelectLanguage('sv')} hideArrow href="#">
            Svenska
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'ru'}>
          <CwsA onClick={() => onSelectLanguage('ru')} hideArrow href="#">
            Русский
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'en'}>
          <CwsA onClick={() => onSelectLanguage('en')} hideArrow href="#">
            English
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'lv'}>
          <CwsA onClick={() => onSelectLanguage('lv')} hideArrow href="#">
            Latviešu
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
        <CwsHeaderLocaleSelectorGroup active={selectedLanguageCode === 'lt'}>
          <CwsA onClick={() => onSelectLanguage('lt')} hideArrow href="#">
            Lietuvių
          </CwsA>
        </CwsHeaderLocaleSelectorGroup>
      </CwsHeaderLocaleSelector>
    </CwsHeaderLocale>
  )
}
